// Only custom modules not loaded via direct <script> tags in scripts.liquid
const moduleRules = [
  { selector: 'product-info-popup', module: '@theme/product-info-popup', priority: 'eager' },
  { selector: 'countdown-timer', module: '@theme/countdown-timer', priority: 'idle' },
  { selector: '.lazyload', module: '@theme/lazysizes', priority: 'eager' },
  { selector: '.splide', module: '@theme/splide', priority: 'idle' },
  { selector: 'overflow-list', module: '@theme/overflow-list', priority: 'eager' },
  { selector: 'accordion-custom', module: '@theme/accordion-custom', priority: 'idle' },
  { selector: 'disclosure-custom', module: '@theme/disclosure-custom', priority: 'idle' },
  {
    selector: 'variant-picker, swatches-variant-picker-component',
    module: '@theme/variant-picker',
    priority: 'eager',
  },
  {
    selector: 'product-form-component, add-to-cart-component',
    module: '@theme/product-form',
    priority: 'eager',
  },
  { selector: 'product-card', module: '@theme/product-card', priority: 'eager' },
  {
    selector: 'quantity-selector-component',
    module: '@theme/component-quantity-selector',
    priority: 'eager',
  },
  { selector: 'product-price', module: '@theme/product-price', priority: 'idle' },
  { selector: 'paypal-message', module: '@theme/paypal-message', priority: 'idle' },
  { selector: 'campaign-offer', module: '@theme/campaign-offer', priority: 'idle' },
  { selector: 'product-sku-component', module: '@theme/product-sku', priority: 'idle' },
  { selector: 'product-inventory', module: '@theme/product-inventory', priority: 'idle' },
  { selector: 'product-title', module: '@theme/product-title', priority: 'idle' },
  { selector: 'show-more-component', module: '@theme/show-more', priority: 'idle' },
  { selector: 'deferred-media, product-model', module: '@theme/media', priority: 'idle' },
  { selector: 'media-gallery', module: '@theme/media-gallery', priority: 'idle' },
  { selector: 'slideshow-component', module: '@theme/slideshow', priority: 'idle' },
  { selector: 'layered-slideshow-component', module: '@theme/layered-slideshow', priority: 'idle' },
  { selector: 'anchored-popover-component', module: '@theme/anchored-popover', priority: 'idle' },
  { selector: 'floating-panel-component', module: '@theme/floating-panel', priority: 'idle' },
  { selector: 'video-background-component', module: '@theme/video-background', priority: 'idle' },
  { selector: 'rte-formatter', module: '@theme/rte-formatter', priority: 'idle' },
  { selector: 'volume-pricing', module: '@theme/volume-pricing', priority: 'idle' },
  { selector: 'price-per-item', module: '@theme/price-per-item', priority: 'idle' },
  { selector: 'volume-pricing-info', module: '@theme/volume-pricing-info', priority: 'idle' },
  {
    selector: 'quick-add-component, quick-add-dialog',
    module: '@theme/quick-add',
    priority: 'idle',
  },
  { selector: 'cart-discount-component', module: '@theme/cart-discount', priority: 'idle' },
  {
    selector:
      'localization-form-component, dropdown-localization-component, drawer-localization-component',
    module: '@theme/localization',
    priority: 'idle',
  },
  { selector: 'sticky-add-to-cart', module: '@theme/sticky-add-to-cart', priority: 'idle' },
  { selector: 'product-card-link', module: '@theme/product-card-link', priority: 'idle' },
  { selector: 'tier-progress', module: '@theme/tier-progress', priority: 'idle' },
  { selector: 'custom-product-grid', module: '@theme/custom-product-grid', priority: 'idle' },
  { selector: 'blog-toc', module: '@theme/blog-toc', priority: 'idle' },
];

const loadedModules = new Set();
let scanScheduled = false;

/**
 * @param {{ (): Promise<void>; (): void; (): void; }} callback
 */
function scheduleIdle(callback) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => callback(), { timeout: 1500 });
    return;
  }

  setTimeout(() => callback(), 0);
}

/**
 * @param {string} module
 */
async function loadModule(module) {
  if (loadedModules.has(module)) return;
  loadedModules.add(module);

  try {
    await import(module);
  } catch (error) {
    loadedModules.delete(module);
    console.error(error);
  }
}

/**
 * @param {{ matches: (arg0: any) => any; querySelector: (arg0: any) => any; }} node
 * @param {string} selector
 */
function nodeMatchesOrContainsSelector(node, selector) {
  if (!(node instanceof Element)) return false;
  if (node.matches(selector)) return true;
  return !!node.querySelector(selector);
}

/**
 * @param {Node | null} root
 */
function scanForModules(root) {
  for (const rule of moduleRules) {
    if (loadedModules.has(rule.module)) continue;

    const matches = root
      ? nodeMatchesOrContainsSelector(root, rule.selector)
      : !!document.querySelector(rule.selector);

    if (!matches) continue;

    if (rule.priority === 'idle') {
      scheduleIdle(() => loadModule(rule.module));
    } else {
      void loadModule(rule.module);
    }
  }
}

function scheduleFullScan() {
  if (scanScheduled) return;
  scanScheduled = true;
  scheduleIdle(() => {
    scanScheduled = false;
    scanForModules(null);
  });
}

scanForModules(null);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      scanForModules(node);
    }
  }

  scheduleFullScan();
});

observer.observe(document.documentElement, { childList: true, subtree: true });
